var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6033 0.182469C11.36 -0.0608229 10.9736 -0.0608229 10.7303 0.182469C10.487 0.42576 10.487 0.812165 10.7303 1.05546C12.9056 3.23077 12.9056 6.76565 10.7303 8.94097C10.487 9.18426 10.487 9.57066 10.7303 9.81395C10.8448 9.92844 11.0022 10 11.1597 10C11.3171 10 11.4745 9.94275 11.589 9.81395C14.2509 7.15206 14.2509 2.83005 11.6033 0.182469Z",
    fill: "#0c3450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.55643 2.2147C9.31314 1.9714 8.92674 1.9714 8.68345 2.2147C8.44015 2.45799 8.44015 2.84439 8.68345 3.08768C9.72817 4.13241 9.74248 5.84976 8.68345 6.89448C8.44015 7.13777 8.44015 7.52418 8.68345 7.76747C8.79794 7.88196 8.95536 7.95351 9.11278 7.95351C9.27021 7.95351 9.42763 7.89627 9.54212 7.76747C11.102 6.23616 11.0877 3.746 9.55643 2.2147Z",
    fill: "#0c3450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.85868 1.05546C3.10197 0.812165 3.10197 0.42576 2.85868 0.182469C2.61538 -0.0608229 2.22898 -0.0608229 1.98569 0.182469C-0.661896 2.83005 -0.661896 7.15206 1.98569 9.79964C2.10018 9.91413 2.2576 9.98569 2.41503 9.98569C2.57245 9.98569 2.72987 9.92844 2.84436 9.79964C3.08766 9.55635 3.08766 9.16995 2.84436 8.92665C0.683363 6.76565 0.683363 3.23077 2.85868 1.05546Z",
    fill: "#0c3450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.89158 3.08768C5.13488 2.84439 5.13488 2.45799 4.89158 2.2147C4.64829 1.9714 4.26189 1.9714 4.0186 2.2147C2.48729 3.746 2.48729 6.23616 4.0186 7.76747C4.13309 7.88196 4.29051 7.95351 4.44793 7.95351C4.60536 7.95351 4.76278 7.89627 4.87727 7.76747C5.12056 7.52418 5.12056 7.13777 4.87727 6.89448C3.84686 5.84976 3.84686 4.13241 4.89158 3.08768Z",
    fill: "#0c3450"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.79375 6.03573C7.37073 6.03573 7.83847 5.568 7.83847 4.99101C7.83847 4.41403 7.37073 3.94629 6.79375 3.94629C6.21676 3.94629 5.74902 4.41403 5.74902 4.99101C5.74902 5.568 6.21676 6.03573 6.79375 6.03573Z",
    fill: "#0c3450"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.ed5ede3b91e994c09e97fa9c43c3da3a.svg";
export { ForwardRef as ReactComponent };